export const firebaseConfig = {
  apiKey: "AIzaSyC11ZHSO4woLziti3SA1Q4Jsrhlx5Puj48",
  authDomain: "luxurysmoke-4522c.firebaseapp.com",
  projectId: "luxurysmoke-4522c",
  storageBucket: "luxurysmoke-4522c.appspot.com",
  messagingSenderId: "562528330610",
  appId: "1:562528330610:web:b230ae0be15843b5dd73eb",
  measurementId: "G-X6YCMTHK1V"
  };